import jwtEncode from "jwt-encode";
import { useParams } from "react-router-dom";
import { applicationId, SSO_URL } from "../../env";

const Login = () => {
  const { channelId } = useParams();
  const currentURL = window.location.href;
  const urlObject = new URL(currentURL);
  let referrerUrlParam = urlObject.searchParams.get("referrer");

  if (!referrerUrlParam) {
    const payload = {
      origin: window.location.origin,
      redirectUri: window.location.pathname,
      applicationId,
    };
    referrerUrlParam = jwtEncode(payload, "");
  }

  return (
    <>
        <div className="sso-parent">
        <iframe
            src={
            channelId
                ? `${SSO_URL}/gateway/web/${channelId}?referrer=${referrerUrlParam}`
                : `${SSO_URL}/gateway/web?referrer=${referrerUrlParam}`
            }
            title="Simulanis SSO"
            style={{ width: "100%", height: "100vh" }}
        />
        </div>
    </>
  )};



export default Login;